new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#footer',
    data: {
        footer: {
            facebook: true, // Facebook icon
            instagram: true, // Instagram icon
            whatsapp: true, // Instagram icon
            youtube: true, // Instagram icon
            ssl: true, // SSL icon
            google: true, // Google safe browser icon
            visa: true, // Visa payment method icon
            diners: true, // Diners payment method icon
            amex: true, // Amex payment method icon
            mastercard: true, // Mastercard payment method icon
            aura: true, // Aura payment method icon
            hipercard: true, // Hipercard payment method icon
            elo: true, // Elo payment method icon
            shoppub: true, // Shoppub plataform icon
        }
    },
})
$(document).ready(function () {
  if(!window.matchMedia("(min-width: 992px)").matches) {
    const footerItems = Array.from(document.querySelectorAll('.header__content > article:not(.header__content--first)'))
    if (footerItems) {
      footerItems.forEach(item => {
        const title = item.querySelector('h3')
        const content = item.querySelector('ul')
        item.addEventListener('click', function(e) {
          title.classList.toggle('active')
          content.classList.toggle('active')
        })
      })
    }
  } else {
    const footerItems = Array.from(document.querySelectorAll('.header__content > article:not(.header__content--first)'))
    footerItems.forEach(item => {
      const content = item.querySelector('ul')
      content.classList.add('uncollapsable')
    })
  }
})